module.exports = __webpack_public_path__ + "img/02.1646c405.jpg";